<template>
    <div class="main">
        <div class="banner">
            <MyHeader class="header"></MyHeader>
            <div class="w1200 h-t">
                <p class="title1">联系我们 <span class="title2">/ </span><span style="font-style:italic">contact us</span></p>
            </div>
        </div>
        <div class="body">
            <div class="w1200">
                <div class="b-item" v-for="(item,key) in list" :key="key">
                    <img :src='item.src' alt="" class="w100">
                    <div class="b-ct">
                        <div class="b-icon">
                            <img :src="item.icon" alt="" class="w100">
                        </div>
                        <p class="b-dis">{{item.title}}</p>
                        <p class="b-yi"></p>
                        <p class="b-tips">{{item.content}}</p>
                    </div>
                </div>
            </div>
            
        </div>
         <div class="bottom">
      <p >
        <span>Copyright © 2019 QINLIAN, All Rights Reserved. </span>
        <a
          target="_blank"
          href="http://beian.miit.gov.cn/"
          style="display:inline-block;text-decoration:underline;height:20px;line-height:30px;color:white;"
        >蜀ICP备19033163号-2 

          <img
            src="@/assets/imgs/8.png"
            style="margin-left:5px;display:inline-block;height:16px;vertical-align: middle;margin-top:-5px;"
          /></a>
      </p>
    </div>
    </div>
</template>
<script>
import MyHeader from '@/components/newHeader.vue'
export default {
    components:{
        MyHeader
    },
    data () {
        return {
            list:[
                {
                    icon:require('@/assets/imgs/us-a.png'),
                    src:require('@/assets/imgs/us-b1.png'),
                    title:'联络地址',
                    content:'成都市OCG国际中心大厦1909'
                },
                {
                   icon:require('@/assets/imgs/us-b.png'),
                    src:require('@/assets/imgs/us-b2.png'),
                    title:'联系电话',
                    content:'13508019337 '
                },{
                    icon:require('@/assets/imgs/us-c.png'),
                    src:require('@/assets/imgs/us-b3.png'),
                    title:'沁链网址',
                    content:'challengechain.cn '
                }
                ,{
                    icon:require('@/assets/imgs/us-d.png'),
                    src:require('@/assets/imgs/us-b4.png'),
                    title:'联络邮箱',
                    content:'201778081@qq.com '
                }
            ]
        }
    }
}
</script>

<style lang="less" scoped>
    .w1200{
        width: 1200px;
        margin:0 auto;
    }
    .w100{
        width: 100%;
        display: block;
    }
    .main{
        width:100%;
        .banner{
            width:100%;
            position: relative;
            height: 352px;
            background-position:50%;
            background:url('../../assets/imgs/us.png') no-repeat;
             //background:url('../../assets/imgs/us1.svg') no-repeat;
            background-size: cover;
            .header{
                width:100%;
                position: absolute;
                left:0;top:0;
                z-index: 55;
                height: 72px;
            }
            .h-t{
                height: 100%;
                position: absolute;
                left:0;right: 0;
                top:0;
                margin:auto;
                text-align: left;
                box-sizing: border-box;
                padding-top:172px;
                .title1{
                    font-size:44px;
                    font-family:SimSun;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    line-height:52px;
                    margin-bottom: 50px;
                }
                .title2{
                    font-size:22px;
                    font-family:Microsoft YaHei;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    line-height:22px;
                }
            }
        }
        .body{
            width:100%;
            height: 460px;
            padding-top:73px;
            box-sizing: border-box;
            .w1200{
                height:330px ;
                display: flex;
                justify-content: space-between;
                .b-item{
                    width:290px;
                    height: 330px;;
                    position: relative;
                    .b-ct{
                        width:100%;
                        height: 100%;
                        position: absolute;
                        left:0;top:0;
                        padding-top:70px;
                        box-sizing: border-box;
                        .b-icon{
                            width:40px;
                            height: 40px;
                            margin:0 auto 15px;
                        }
                        .b-dis{
                            text-align: center;
                            font-size:26px;
                            font-family:Source Han Sans CN;
                            font-weight:300;
                            color:rgba(51,51,51,1);
                            margin-bottom: 45px;
                        }
                        .b-yi{
                           width:20px;
                            height:3px;
                            background:rgba(57,172,95,1); 
                            margin:0 auto 24px;
                        }
                        .b-tips{
                            text-align: center;
                            font-size:18px;
                            font-family:Source Han Sans CN;
                            font-weight:bold;
                            color:rgba(51,51,51,1);
                        }
                    }
                }
            }
        }
        .bottom{
    height: 88px;
    line-height: 88px;
    background-color: #181818;
    p{
      height: 15px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
    }
</style>